import { faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { removeTokens } from '../api/auth';
import GeneralForm from '../components/GeneralForm';
import ImpuestosForm from '../components/ImpuestosForm';
import LicenciaForm from '../components/LicenciaForm';
import PredialForm from '../components/PredialForm';
import RPPForm from '../components/RPPForm';
import RegistroCivilForm from '../components/RegistroCivilForm';
import TabsMenu from '../components/TabsMenu';
import VehicularForm from '../components/VehicularForm';


const Home = () => {
  const [results, setResults] = useState([]);
  const [activeTab, setActiveTab] = useState('general');
  const [user, setUser] = useState(null); 



 

  const handleResults = (data) => {
    setResults(data);
    if (data.username) {
      setUser(data.username);
    }
  };

  const changeTab = (tab) => {
    setActiveTab(tab);
  };

  const handleSignOut = () => {
    removeTokens();
    window.location.href = '/sign-in';
  }; 

  return  (
    <div className="container">
            <div className="top-bar2">
      <div className="top-bar">
        <div className="logo">
          <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px' }} />
        </div>
        <button className="user">
          <FontAwesomeIcon icon={faUser} />
        </button>
        <button className="sign-out-button" onClick={handleSignOut}>
          <FontAwesomeIcon icon={faSignOutAlt} />
          Salir
        </button>
      </div>
      </div>
      <h1 className='padrones-titulo'> Consulta Padrones </h1>
      <div className=' bnd'>
      {user && <div>Bienvenido, {user.NAME}</div>} 
      
      </div>
      <TabsMenu activeTab={activeTab} changeTab={changeTab} />
      <RenderForm activeTab={activeTab} handleResults={handleResults} setResults={setResults} results={results} />
      <footer style={{ textAlign: 'center' }}>
        Copyright © Gobierno del Estado de Durango 2024
      </footer>
    </div>
  );
};

function RenderForm(props) {
  const { activeTab, handleResults, setResults, results } = props;

  switch (activeTab) {
    case 'general':
      return <GeneralForm submitCallback={handleResults} />;
    case 'impuestos':
      return <ImpuestosForm submitCallback={handleResults} />;
    case 'licencia':
      return <LicenciaForm submitCallback={handleResults} />;
    case 'predial':
      return <PredialForm submitCallback={handleResults} />;
    case 'rpp':
      return <RPPForm submitCallback={handleResults} />;
    case 'registroCivil':
      return <RegistroCivilForm submitCallback={handleResults} />;
    case 'vehicular':
      return <VehicularForm setResults={setResults} results={results} />;
    default:
      return null;
  }
}

export default Home;
